import { useEffect, useState } from "react";
import { Route, Switch, useLocation } from "react-router-dom";
import {
  CompleteProfileModal,
  DeviceAccessModal,
  GiftModal,
  Header,
  LoginModal,
  LoginPermissionModal,
  LogoutModal,
  MessageModal,
  ProfileCompletedMessageModal,
} from "src/components";
import { Routes } from "./routes";
import { RouteService, SeoService, UIService } from "src/services";

export const MainLayout: React.FC = () => {
  const location = useLocation();
  const currentRoute = RouteService.getCurrentRoute();
  const isEmbedded = UIService.isEmbedded();
  const [loginParam] = useState(UIService.getLoginParam());

  useEffect(() => {
    try {
      window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
    } catch {
      window.scrollTo(0, 0);
    }

    if (currentRoute?.dontSetTitle) return;

    const title = currentRoute?.title || (() => "");

    SeoService.setHeaderMetadata(title());
  }, [location, currentRoute, loginParam]);

  return (
    <>
      <Switch>
        <Route path="/">
          <Switch>
            <>
              {!currentRoute?.noLayout && !isEmbedded && (
                <Header hideForZarebin={!!loginParam} />
              )}
              <Routes />
            </>
          </Switch>
        </Route>
      </Switch>
      <GiftModal />
      <LoginModal />
      <LogoutModal />
      <DeviceAccessModal />
      <MessageModal />
      <LoginPermissionModal />
      <CompleteProfileModal />
      <ProfileCompletedMessageModal />
    </>
  );
};
